import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CPR_RESULT_STORE_NAME, CprResultState } from './cpr-result.state';

/** Select CprResult State */
export const selectCprResultState = createFeatureSelector<CprResultState>(CPR_RESULT_STORE_NAME);

/** Select CprResult isPending status */
export const selectCprResultIsPendingStatus = createSelector(selectCprResultState, (state) => !!state.isPending);

/** Select CprResult isFailure status */
export const selectCprResultIsFailureStatus = createSelector(selectCprResultState, (state) => !!state.isFailure);

/** 非自動生成: Select PostJourneysGetJourneyResponse */
export const selectCprResult = createSelector(selectCprResultState, (state) => state.model);
